module.exports = __webpack_public_path__ + "img/Ing_microtech_06_TPA.2d3da2db.jpg";